












































































































































































































































































































































































































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { rules, scrollToFirstInvalidElement } from "../../services/validation";
import * as types from "../../store/types";

function parseNumber(value: string) {
  if (!value) return 0;

  const cleaned = value.replace(/[^0-9.]/g, "");
  if (!cleaned || Number.isNaN(cleaned)) return 0;

  return parseFloat(cleaned);
}

export default Vue.extend({
  name: "ApplicationStep2",

  props: {},

  data: () => {
    return {
      rules,
      formValue: {
        ownRentSpace: null,
        ownRentSpaceType: "",
        ownRentSpaceComment: "",
        fullTimeCount: "",
        partTimeCount: "",
        contractCount: "",

        estIncreasedExpenditures: "",
        estLostProfit: "",
        estLostProfitDesc: "",

        reliefSourcePpp: "",
        reliefSourceSba: "",
        reliefSourceCounty: "",
        reliefSourceCity: "",
        reliefSourceUnemployment: "",
        reliefSourceOther: "",
        reliefSourceOtherLabel: "",
        reliefSourceArpaGreene: "",
        reliefSourceArpaMo: "",

        proposedProjectDesc1: "",
        proposedProjectAmount1: "",
        proposedProjectDesc2: "",
        proposedProjectAmount2: "",
        proposedProjectDesc3: "",
        proposedProjectAmount3: "",
      },
    };
  },

  methods: {
    ...mapActions({
      saveStep: types.SAVE_FORM_STEP,
    }),
    saveAndContinue() {
      this.saveStep({
        formFields: this.formValue,
      }).then(() => {
        // sometimes this if firing before the application-level validation, which reset the validation state, so we wait a little longer to be safe.
        setTimeout(() => {
          // @ts-ignore
          const isValid = this.$refs.form.validate();
          this.$emit("update-validity", 1, isValid);
          if (!isValid) {
            return scrollToFirstInvalidElement(this, this.$refs.form as Vue);
          }

          this.$emit("next-step");
        }, 500);
      });
    },
    save() {
      this.saveStep({
        formFields: this.formValue,
      });
    },
    updateValidity() {
      // @ts-ignore
      const formIsValid = this.$refs.form.validate();
      // @ts-ignore
      this.$refs.form.resetValidation();

      this.$emit("update-validity", 1, formIsValid);
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
      saving: types.SAVING_FORM,
    }),

    spaceGrantTotal(): number {
      const amountMap = {
        "Commercial retail or manufacturing space": 5000,
        "Commercial warehouse/storage": 3000,
        "I live on a farm, ranch, or venue that is the business": 2000,
        "Booth rental space": 1000,
        "I operate my business and store materials at my personal residence": 0,
      };

      // @ts-ignore
      return amountMap[this.formValue.ownRentSpaceType] || 0;
    },
    fullTimeTotal(): number {
      return parseNumber(this.formValue.fullTimeCount) * 500;
    },
    partTimeTotal(): number {
      return parseNumber(this.formValue.partTimeCount) * 250;
    },
    contractTotal(): number {
      return parseNumber(this.formValue.contractCount) * 250;
    },
    maxAllowedTotal(): number {
      const total =
        5000 +
        this.spaceGrantTotal +
        this.fullTimeTotal +
        this.partTimeTotal +
        this.contractTotal;

      const thisYearTotal = total > 49999.99 ? 49999.99 : total;

      const allTimeGreeneTotal =
        parseNumber(this.formValue.reliefSourceArpaGreene) + thisYearTotal;

      if (allTimeGreeneTotal > 49999.99) {
        return thisYearTotal - (allTimeGreeneTotal - 49999.99);
      } else {
        return thisYearTotal;
      }
    },

    totalAwardCalculation(): number {
      return Math.max(
        0,
        Math.min(this.maxAllowedTotal, this.totalNetEstImpact)
      );
    },

    estImpactToDate(): number {
      return (
        parseNumber(this.formValue.estLostProfit) +
        parseNumber(this.formValue.estIncreasedExpenditures)
      );
    },

    totalReliefToDate(): number {
      return (
        parseNumber(this.formValue.reliefSourcePpp) +
        parseNumber(this.formValue.reliefSourceSba) +
        parseNumber(this.formValue.reliefSourceCounty) +
        parseNumber(this.formValue.reliefSourceCity) +
        parseNumber(this.formValue.reliefSourceUnemployment) +
        parseNumber(this.formValue.reliefSourceArpaGreene) +
        parseNumber(this.formValue.reliefSourceArpaMo) +
        parseNumber(this.formValue.reliefSourceOther)
      );
    },
    totalNetEstImpact(): number {
      return this.estImpactToDate - Math.max(0, this.totalReliefToDate);
    },
  },

  watch: {
    allFormValues: {
      immediate: true,
      handler() {
        // map this step's fields to Vuex's
        Object.keys(this.formValue).forEach(
          // @ts-ignore
          (key) => (this.formValue[key] = this.allFormValues[key])
        );

        setTimeout(() => this.updateValidity(), 50);
      },
    },
  },
});
